module.exports = __webpack_public_path__ + "media/src/images/abouts/buttons/google-play-badge-9fe963d8aae83c1939c2e20ca7852875.png";